import config from '@/config'

interface validatePhoneInterface {
  [key:string]: (phoneNumber: string) => boolean;
}

// 校验多国家地区手机号规则
const validatePhone: validatePhoneInterface = {
  // 巴西
  'pt': (phoneNumber: string) => {
    if (phoneNumber && 11 == phoneNumber.length) {
      const e = parseInt(phoneNumber.substring(0, 2), 10),
        i = parseInt(phoneNumber.charAt(2), 10);
      return e >= 11 && e <= 99 && 9 == i;
    }
    return !1;
  },
};

// 手机号判断
export const validatePhoneNumber:any = (number: string) => {
  return validatePhone[config.nationName] && validatePhone[config.nationName](number);
};

// 密码限制8~20个数字
export const validatePassword = (password: string) => {
  return password.length >= 8 && password.length <= 20;
};
// 验证登录的账号输入
export const validateAccount = (account: string) => {
  if (!account || account.length < 6) return !1;
  return !!/^[0-9a-zA-Z]*$/g.test(account);
};
// 验证码限制4位数
export const phoneCodeLimit = (password: string) => {
  return password.length == 4;
};
